#import '../../fragments/userProfile.fragment.graphql'

mutation removeItemFromCart($itemId: String!) {
  removeItemFromCart(input: { itemId: $itemId }) {
    userProfile {
      ...UserProfileFragment
    }
  }
}
